import { medicalInformationTopic } from './medicalInformationTopic';
import { profileInformationTopic } from './profileInformationTopic';
import { tachoInfringementsTopic } from './tachoInfringementsTopic';

// Every review topic the complete-review wizard can present a step for. A topic declares its own
// step, state, load, gating, dirty check and comment, so adding one means adding its module and
// listing it here - the wizard page itself drives entirely off this list. A topic the API returns
// with no module here has no step and is submitted unreviewed, so a new topic can be added
// backend-first.
const reviewTopics = [
    profileInformationTopic,
    medicalInformationTopic,
    tachoInfringementsTopic
];

// The state every topic starts in, keyed by topic key. Held for all known topics rather than the
// review's own, because the review - and so its topics - is not known until it has loaded.
export function initialTopicStates() {
    return reviewTopics.reduce((states, topic) => {
        return { ...states, [topic.key]: topic.createInitialState() };
    }, {});
}

// The topics of a pending review that the wizard has a module for, in the order the API returns
// them, which is the order their steps appear in.
export function getReviewTopics(pendingReview) {
    return (pendingReview?.topics ?? [])
        .map((topic) => reviewTopics.find((candidate) => candidate.key === topic.topicKey))
        .filter((topic) => topic != null);
}

// The comment captured against each topic that has a step, keyed by topic key, so completion
// submits those topics as reviewed with their comment.
export function buildTopicComments(topics, topicStates) {
    return topics.reduce((comments, topic) => {
        return { ...comments, [topic.key]: topic.getComment(topicStates[topic.key]) };
    }, {});
}

// The answers each topic sends with the completion request beyond its comment, keyed by topic
// key. Only a topic whose answers are persisted by completing the review provides them.
export function buildTopicRequestFields(topics, topicStates) {
    return topics
        .filter((topic) => topic.getRequestFields != null)
        .reduce((fields, topic) => {
            return { ...fields, [topic.key]: topic.getRequestFields(topicStates[topic.key]) };
        }, {});
}
